function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1-picto_mail{fill:inherit;}\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 24,
  height: 24
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-"
}, /*#__PURE__*/React.createElement("g", {
  id: "Invite-people-via-email-in-on-boarding_x23_1_x5F_long_x5F_list",
  transform: "translate(-42.000000, -143.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(27.000000, 132.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "picto_x2F_mail",
  transform: "translate(13.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Combined-Shape"
}, /*#__PURE__*/React.createElement("path", {
  id: "path-1_1_",
  className: "st1-picto_mail",
  d: "M24,6v18H4V6H24z M22,9.1L13.9,17L6,9.2V22h16V9.1z M20.4,8H7.6l6.4,6.3L20.4,8z"
}))))));

var SvgPictoMail = function SvgPictoMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPictoMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picto_mail.a0b34b41.svg";
export { ForwardRef as ReactComponent };